export const translations = {
  en: {
    brand: "Dataleo Supply Chain AI Radar",
    nav: {
      home: "Home",
      news: "News",
      jobs: "Jobs",
      alerts: "Alerts",
      insights: "Insights",
      tutorials: "Tutorials",
      ecosystem: "Ecosystem",
      about: "About",
      admin: "Admin",
    },
    tagline: "AI news for Operations leaders. Less hype. More decision impact.",
    hero: {
      title: "AI is entering Supply Chain.",
      title2: "The question is no longer what can be built.",
      title3: "The question is what can be trusted.",
      subtitle:
        "Dataleo Supply Chain AI Radar tracks news, jobs, tools and signals at the intersection of AI, Supply Chain, planning and operational decision-making.",
      ctaNews: "Browse the radar",
      ctaAbout: "What is Dataleo",
      band1: "Supply Chain AI · daily radar",
      band2: "Less hype. More decision impact.",
    },
    sections: {
      latestNews: "Latest Supply Chain AI news",
      featured: "Featured analysis",
      latestJobs: "Latest jobs",
      latestAlerts: "Latest alerts",
      latestTutorials: "Latest tutorials",
      latestEcosystem: "Supply Chain AI ecosystem",
      ecosystemDesc: "Vendors, service providers and experts shaping the new decision chain.",
      topics: "Explore by topic",
      newsletter: "Get the weekly radar",
      newsletterDesc:
        "One short email per week. AI signals that matter for Operations leaders. No hype.",
      newsletterFirstName: "First name",
      newsletterLastName: "Last name",
      newsletterEmail: "Your work email",
      newsletterCta: "Subscribe",
      newsletterOk: "You're in. We'll keep it useful.",
      newsletterAlready: "Already subscribed. Thank you.",
      newsletterError: "Please fill in your name and a valid email.",
      positioning: "What Dataleo does",
      readMore: "Read more",
      viewAll: "View all",
      seeOriginal: "Read the source",
      apply: "View role",
      readTutorial: "Read tutorial",
      minutes: "min read",
    },
    filters: {
      all: "All",
      language: "Language",
      category: "Topic",
      relevance: "Relevance area",
      impact: "Impact level",
      severity: "Severity",
      country: "Country",
      workMode: "Work mode",
      seniority: "Seniority",
      difficulty: "Difficulty",
      search: "Search…",
      reset: "Reset filters",
      period: "Published",
      periodAll: "All time",
      periodToday: "Today",
      periodWeek: "This week",
      periodMonth: "This month",
      periodQuarter: "This quarter",
      periodYear: "This year",
    },
    labels: {
      impact: "Impact",
      severity: "Severity",
      source: "Source",
      published: "Published",
      dataleoAngle: "The Dataleo angle",
      company: "Company",
      location: "Location",
      function: "Function",
      tags: "Tags",
      en: "English",
      fr: "French",
    },
    about: {
      title: "Build fast. Govern properly. Scale only what works.",
      lead:
        "Supply Chain teams can now build planning tools in days. But without governance, decision architecture and data control, this creates the next generation of shadow IT.",
      p1:
        "Dataleo helps companies frame the decision, build fast, govern properly and scale only what works. We work with Supply Chain leaders, operations teams and IT to industrialize AI-built decision tools without losing control.",
      pull:
        "The real value is not the AI-built app. The real value is the governed decision system behind it.",
      p2:
        "Our radar tracks the signals that matter - products, vendor movements, regulation, jobs, governance risks - and translates them into decision impact for Operations leaders.",
    },
    positioning: {
      eyebrow: "About Dataleo",
      title: "AI-built tools need decision architecture",
      body:
        "Dataleo helps Supply Chain and Operations leaders build governed AI decision systems. We frame the decision, build fast with AI, govern properly and scale only what works.",
      cta: "Learn about Dataleo",
    },
    topics: [
      "AI in Supply Chain", "Planning", "Inventory", "S&OP / IBP",
      "Sourcing / Procurement", "Manufacturing", "Warehousing / Logistics", "IT & AI Governance",
    ],
    tutorials: {
      title: "Tutorials & How-to",
      subtitle: "Practical, field-tested guides for building governed AI decision systems.",
      duration: "Duration",
    },
    admin: {
      title: "Backoffice",
      passwordPlaceholder: "Admin password",
      login: "Sign in",
      logout: "Sign out",
      add: "Add new",
      edit: "Edit",
      delete: "Delete",
      save: "Save",
      cancel: "Cancel",
      empty: "No content yet.",
      invalid: "Invalid password",
      subscribers: "Subscribers",
      exportCsv: "Export CSV",
      autoTranslate: "Auto-translate to other language",
      translating: "Translating…",
    },
    footer: { rights: "All rights reserved.", built: "A Dataleo property." },
    severity: { Info: "Info", Event: "Event", Nomination: "Nomination", Indiscretion: "Indiscretion" },
    impact: { Low: "Low", Medium: "Medium", High: "High" },
  },
  fr: {
    brand: "Dataleo Supply Chain AI Radar",
    nav: {
      home: "Accueil",
      news: "Actualités",
      jobs: "Emplois",
      alerts: "Alertes",
      insights: "Analyses",
      tutorials: "Tutoriels",
      ecosystem: "Écosystème",
      about: "À propos",
      admin: "Admin",
    },
    tagline:
      "L'actualité IA pour les leaders Opérations. Moins de hype. Plus d'impact décisionnel.",
    hero: {
      title: "L'IA entre dans la Supply Chain.",
      title2: "La question n'est plus ce que l'on peut construire.",
      title3: "La question est ce à quoi l'on peut faire confiance.",
      subtitle:
        "Dataleo Supply Chain AI Radar suit les actualités, emplois, outils et signaux à l'intersection de l'IA, de la Supply Chain, de la planification et de la décision opérationnelle.",
      ctaNews: "Parcourir le radar",
      ctaAbout: "Qui est Dataleo",
      band1: "Supply Chain IA · radar quotidien",
      band2: "Moins de hype. Plus d'impact décisionnel.",
    },
    sections: {
      latestNews: "Dernières actualités Supply Chain IA",
      featured: "Analyse à la une",
      latestJobs: "Derniers emplois",
      latestAlerts: "Dernières alertes",
      latestTutorials: "Derniers tutoriels",
      latestEcosystem: "Écosystème Supply Chain IA",
      ecosystemDesc: "Éditeurs, cabinets et experts qui façonnent la nouvelle chaîne de décision.",
      topics: "Explorer par thème",
      newsletter: "Recevez le radar hebdo",
      newsletterDesc:
        "Un email court par semaine. Les signaux IA qui comptent pour les leaders Opérations. Sans hype.",
      newsletterFirstName: "Prénom",
      newsletterLastName: "Nom",
      newsletterEmail: "Votre email professionnel",
      newsletterCta: "S'abonner",
      newsletterOk: "Inscription confirmée. On reste utiles.",
      newsletterAlready: "Vous êtes déjà inscrit. Merci.",
      newsletterError: "Merci de saisir votre nom et un email valide.",
      positioning: "Ce que fait Dataleo",
      readMore: "Lire la suite",
      viewAll: "Voir tout",
      seeOriginal: "Voir la source",
      apply: "Voir le poste",
      readTutorial: "Lire le tutoriel",
      minutes: "min de lecture",
    },
    filters: {
      all: "Tous",
      language: "Langue",
      category: "Thème",
      relevance: "Domaine",
      impact: "Niveau d'impact",
      severity: "Sévérité",
      country: "Pays",
      workMode: "Mode de travail",
      seniority: "Séniorité",
      difficulty: "Niveau",
      search: "Rechercher…",
      reset: "Réinitialiser",
      period: "Publié",
      periodAll: "Toutes périodes",
      periodToday: "Aujourd'hui",
      periodWeek: "Cette semaine",
      periodMonth: "Ce mois",
      periodQuarter: "Ce trimestre",
      periodYear: "Cette année",
    },
    labels: {
      impact: "Impact",
      severity: "Sévérité",
      source: "Source",
      published: "Publié",
      dataleoAngle: "L'angle Dataleo",
      company: "Entreprise",
      location: "Lieu",
      function: "Fonction",
      tags: "Tags",
      en: "Anglais",
      fr: "Français",
    },
    about: {
      title:
        "Construire vite. Gouverner correctement. Mettre à l'échelle uniquement ce qui fonctionne.",
      lead:
        "Les équipes Supply Chain peuvent désormais construire des outils de planification en quelques jours. Mais sans gouvernance, architecture de décision et contrôle des données, cela crée la prochaine génération de shadow IT.",
      p1:
        "Dataleo aide les entreprises à cadrer la décision, construire vite, gouverner correctement et mettre à l'échelle uniquement ce qui fonctionne. Nous travaillons avec les leaders Supply Chain, les équipes opérations et la DSI pour industrialiser les outils de décision construits avec l'IA sans perdre le contrôle.",
      pull:
        "La vraie valeur n'est pas l'application construite par IA. La vraie valeur est le système de décision gouverné qui se trouve derrière.",
      p2:
        "Notre radar suit les signaux qui comptent - produits, mouvements d'éditeurs, régulation, emplois, risques de gouvernance - et les traduit en impact décision pour les leaders Opérations.",
    },
    positioning: {
      eyebrow: "À propos de Dataleo",
      title: "Les outils construits avec l'IA ont besoin d'une architecture de décision",
      body:
        "Dataleo aide les leaders Supply Chain et Opérations à construire des systèmes de décision IA gouvernés. Nous cadrons la décision, construisons vite avec l'IA, gouvernons correctement et passons à l'échelle seulement ce qui fonctionne.",
      cta: "En savoir plus sur Dataleo",
    },
    topics: [
      "IA Supply Chain", "Planification", "Stocks", "S&OP / IBP",
      "Achats / Sourcing", "Production", "Entrepôts / Logistique", "Gouvernance IT & IA",
    ],
    tutorials: {
      title: "Tutoriels & How-to",
      subtitle: "Guides pratiques, testés sur le terrain, pour construire des systèmes de décision IA gouvernés.",
      duration: "Durée",
    },
    admin: {
      title: "Backoffice",
      passwordPlaceholder: "Mot de passe admin",
      login: "Se connecter",
      logout: "Se déconnecter",
      add: "Ajouter",
      edit: "Modifier",
      delete: "Supprimer",
      save: "Enregistrer",
      cancel: "Annuler",
      empty: "Pas encore de contenu.",
      invalid: "Mot de passe invalide",
      subscribers: "Abonnés",
      exportCsv: "Exporter CSV",
      autoTranslate: "Traduire automatiquement dans l'autre langue",
      translating: "Traduction en cours…",
    },
    footer: { rights: "Tous droits réservés.", built: "Une marque Dataleo." },
    severity: { Info: "Info", Event: "Événement", Nomination: "Nomination", Indiscretion: "Indiscrétion" },
    impact: { Low: "Faible", Medium: "Moyen", High: "Élevé" },
  },
};
